import type { ClientEnrichedCircular } from "~/routes/api.circulars";

const SORT_DIRECTIONS = {
  asc: 1,
  desc: -1,
} as const;

type SortDirection = keyof typeof SORT_DIRECTIONS;
type CircularSortKey =
  | "title"
  | "circularId"
  | "publishedFrom"
  | "ackLastReceivedAt";

export type Sort = {
  by: CircularSortKey;
  direction?: SortDirection;
};

export const sortCirculars = ({
  circulars,
  sort,
}: {
  circulars: ClientEnrichedCircular[];
  sort?: Sort;
}): ClientEnrichedCircular[] => {
  if (!sort) {
    return circulars;
  }

  const { by, direction = "asc" } = sort;

  return circulars.sort((a, b) => {
    let aValue: string | null | undefined;
    let bValue: string | null | undefined;
    switch (by) {
      case "publishedFrom":
        aValue = a.publication?.[by];
        bValue = b.publication?.[by];
        break;
      case "ackLastReceivedAt":
        aValue = a.circularAck?.[by];
        bValue = b.circularAck?.[by];
        break;
      default:
        aValue = a[by];
        bValue = b[by];
    }

    if (!aValue && !bValue) {
      return 0;
    } else if (!aValue) {
      return 1;
    } else if (!bValue) {
      return -1;
    }

    return aValue.localeCompare(bValue, "nb") * SORT_DIRECTIONS[direction];
  });
};
